"use strict";
import React from "react";
import classnames from "classnames";
import Avatar, { AvatarType } from "../../../pieces/Avatar/Avatar";
import { Tick } from "../../../icons";
const BASE_CLASS_NAME = "user-card";
const UserCard = ({
  user,
  selected = false,
  onClick,
  children,
  className,
  avatarType = AvatarType.User
}) => {
  const avatarNameProps = avatarType === AvatarType.User ? { firstName: user.firstName, lastName: user.lastName } : {};
  return /* @__PURE__ */ React.createElement(
    "div",
    {
      className: classnames(BASE_CLASS_NAME, className, {
        [`${BASE_CLASS_NAME}--selected`]: selected
      }),
      onClick
    },
    /* @__PURE__ */ React.createElement(Avatar, { type: avatarType, ...avatarNameProps }),
    /* @__PURE__ */ React.createElement("div", { className: `${BASE_CLASS_NAME}__details` }, /* @__PURE__ */ React.createElement("span", { className: `${BASE_CLASS_NAME}__name` }, `${user.firstName} ${user.lastName || ""}`), user.email && /* @__PURE__ */ React.createElement("span", { className: `${BASE_CLASS_NAME}__email` }, user.email)),
    /* @__PURE__ */ React.createElement("div", { className: `${BASE_CLASS_NAME}__spacer` }),
    /* @__PURE__ */ React.createElement("div", { className: `${BASE_CLASS_NAME}__children`, onClick: (event) => event.stopPropagation() }, children),
    selected && /* @__PURE__ */ React.createElement(Tick, { className: `${BASE_CLASS_NAME}__tick` })
  );
};
export default UserCard;
